import type { Money, MoneyRange } from "@reno-estimator/core";

const currencyFormatter = new Intl.NumberFormat("en-CA", {
  style: "currency",
  currency: "CAD",
  maximumFractionDigits: 0
});

/** All engine output is already rounded to sensible planning increments - this only handles locale/currency display, never math. */
export function formatMoney(money: Money): string {
  return currencyFormatter.format(money.amount);
}

export function formatMoneyRange(range: MoneyRange): string {
  return `${formatMoney(range.low)} – ${formatMoney(range.high)}`;
}

export function formatDate(iso: string): string {
  try {
    return new Intl.DateTimeFormat("en-CA", { year: "numeric", month: "long", day: "numeric" }).format(new Date(iso));
  } catch {
    return iso;
  }
}
